import { useCVStore } from '../store/useCVStore';
import { supabase } from '../lib/supabase';

function addCheckmarksToKeyCompetencies(text) {
  const sectionHeaders = ['COMPÉTENCES CLÉS', 'KEY COMPETENCIES'];
  const nextSectionPrefixes = [
    'EXPÉRIENCES', 'PROFESSIONAL EXPERIENCE', 'FORMATION', 'EDUCATION',
    'CERTIFICATIONS', 'COMPÉTENCES TECHNIQUES', 'TECHNICAL SKILLS',
  ];
  const lines = text.split('\n');
  let inKeyCompetencies = false;
  return lines.map(line => {
    const trimmed = line.trim();
    if (sectionHeaders.some(h => trimmed.toUpperCase() === h || trimmed.toUpperCase().startsWith(h + '\n'))) {
      inKeyCompetencies = true;
      return line;
    }
    if (inKeyCompetencies && trimmed && nextSectionPrefixes.some(p => trimmed.toUpperCase().startsWith(p))) {
      inKeyCompetencies = false;
      return line;
    }
    if (inKeyCompetencies && trimmed && !trimmed.startsWith('✓') && !/^[-•*]/.test(trimmed)) {
      return '✓ ' + trimmed;
    }
    return line;
  }).join('\n');
}

export const useCVAdaptation = () => {
  const { 
    setIsGenerating, 
    setAdaptedText, 
    setError,
    originalText,
    jobDescription
  } = useCVStore();

  const adaptCV = async (customInstructions = '', language = 'fr', mode = 'cv') => {
    setIsGenerating(true);
    setError(null);

    try {
      const { data, error } = await supabase.functions.invoke('adapt-cv', {
        body: { 
          cvText: originalText, 
          jobDescription, 
          customInstructions, 
          language,
          mode
        }
      });

      if (error) {
        console.error('Supabase Function Error:', error);
        throw new Error(error.message || 'La fonction Edge a retourné une erreur.');
      }

      const processed = addCheckmarksToKeyCompetencies(data.adaptedContent);
      setAdaptedText(processed);
      return processed;
    } catch (err) {
      const message = err.message || 'Une erreur est survenue lors de l\'adaptation.';
      setError(message);
      throw err;
    } finally {
      setIsGenerating(false);
    }
  };

  return { adaptCV };
};
